import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { partnerPickDevicesPartnerScopedAccessControl } from '../access-control/partnerPickDevicesPartnerScopedAccess.configuration'

const PartnerPickDevicesListPartnerScopedPage = lazy(
  () => import('../pages/list/PartnerPickDevicesListPartnerScopedPage')
)

export const partnerPickDevicesPartnerScopedRouter = (
  <DomainRoute
    route="partner-pick-devices-partner-scoped"
    accessControl={partnerPickDevicesPartnerScopedAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="partner-pick-devices-partner-scoped-list"
        component={PartnerPickDevicesListPartnerScopedPage}
      />
    </DashSwitch>
  </DomainRoute>
)
